import { v4 as uuid } from 'uuid';
import useLazyRef from './useLazyRef';

/**
 * Will create a unique id to be used during the whole component lifecycle, will persist renders, but it will be a new id
 * if the component is unmounted and mounted.
 * @return {string} UUID - Unique ID that persists between renders.
 */

export default function useUniqueId() {
  return useLazyRef(() => uuid()).current;
}
